export const CornerstoneDescriptionBody = ({ bod }) => {
  return (
    <div className="description-section-two">
      <br />
      <br />
      <br />
      <br />
      <br />
      Cornerstone Partners organises an annual nine-week Cornerstone program
      designed to challenge, connect and drive the growth of black and diverse
      businesses.
      <br />
      <br />
      The nine-week program is to enable 20 black and diverse founders to scale
      their business operations, absorb cutting-edge knowledge from operators
      and significantly grow their network of investors.
    </div>
  );
};
